/* eslint-disable*/
import VueStoreService from './VueStoreService';
const DetailImportService = {
  //DETAIL IMPORT
  async saveDetail(data, store) {
    var resp = await VueStoreService.post("detail-import", data, store)
    return resp;
  },
  async getDetailxImport(import_id, store) {
    var resp = await VueStoreService.get("detail-import/" + import_id, store)
    return resp;
  },
  
  async deleteDetail(detail_id, store) {
    var resp = await VueStoreService.delete("detail-import/" + detail_id, store)
    return resp;
  },
}

export default DetailImportService;